import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Picking Types */
import {
  Settings,
  _Picking
} from '../namespace-helper'

import _ from 'lodash'

// selected item template
const selectedPickingTemplate = {
  id: 0,
  invoices_id: 0,
  packagings_types_id: 0,
  documents_id: 0
}

export default {
  namespaced: true,
  state: {
    pickings: [],
    selectedPicking: _.cloneDeep(selectedPickingTemplate),
    openDialog: false,
    creatingPickingList: false
  },
  mutations: {
    [_Picking.mutations.setPickings] (state, payload) {
      state.pickings = payload
    },
    [_Picking.mutations.setSelectedPicking] (state, payload) {
      if (payload !== null) {
        state.selectedPicking = payload
      } else {
        state.selectedPicking = _.cloneDeep(selectedPickingTemplate)
      }
    },
    [_Picking.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_Picking.actions.savePicking] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/pickings'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            context.commit(_Picking.mutations.setSelectedPicking, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/pickings/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Picking.actions.loadPickingsForInvoiceId] (context, payload) {
      console.log('loadPickings: ' + JSON.stringify(payload))
      console.log('loadPickings: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/pickings/invoice/' + payload.id + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'invoice_number:like;' +
                'colli_number:like;' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedInvoices: ' + JSON.stringify(r.data.data))
        context.commit(_Picking.mutations.setPickings, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Picking.actions.openCloseDialog] ({ commit }) {
      commit(_Picking.mutations.setOpenCloseDialogState)
    },
    [_Picking.actions.setSelectedPicking] ({ commit }, payload) {
      commit(_Picking.mutations.setSelectedPicking, payload)
    },
    [_Picking.actions.clearPickings] ({ commit }, payload) {
      commit(_Picking.mutations.setPickings, [])
    },
    [_Picking.actions.loadPackageTypes] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/packageTypes'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Picking.actions.deletePicking] (context, payload) {
      var url = API_URL + '/api/v1/pickings/' + payload.id

      console.log('deletePicking: ' + payload.id)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Picking.actions.createPickingList] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/pickings/createPickingList/' + payload.id

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Picking.actions.finishPicking] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/pickings/' + payload.id + '/finish'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Picking.actions.reloadPicking] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/pickings/' + payload.id
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          context.commit(_Picking.mutations.setSelectedPicking, r.data.data)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Picking.actions.resetState] ({ commit }, payload) {
      commit(_Picking.mutations.setPickings, [])
      commit(_Picking.mutations.setSelectedPicking, null)
    }

  },
  getters: {
    [_Picking.getters.pickings] (state) {
      return state.pickings
    },
    [_Picking.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_Picking.getters.getSelectedPicking] (state) {
      return state.selectedPicking
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Picking/pickings.js